export default __webpack_public_path__ + "static/media/Golden galaxy1.687237c4.jpg";